/**
 * Práh dopravy zdarma v halířích. Drží se na jednom místě, ať service bar
 * v hlavičce i lišta v košíku ukazují stejné číslo.
 */
export const FREE_SHIPPING_MINOR = 150_000;

/** Ceny chodi ze serveru v halerich jako integer. Tady se jen zobrazuji. */
export function formatCzk(minor: number): string {
  return new Intl.NumberFormat('cs-CZ', {
    style: 'currency',
    currency: 'CZK',
    maximumFractionDigits: minor % 100 === 0 ? 0 : 2,
    minimumFractionDigits: minor % 100 === 0 ? 0 : 2,
  }).format(minor / 100);
}

export function formatPriceRange(fromMinor: number, toMinor: number): string {
  return fromMinor === toMinor ? formatCzk(fromMinor) : `od ${formatCzk(fromMinor)}`;
}

export function discountPercent(priceMinor: number, compareAtMinor: number | null): number | null {
  if (compareAtMinor === null || compareAtMinor <= priceMinor) return null;
  return Math.floor(((compareAtMinor - priceMinor) / compareAtMinor) * 100);
}
